import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import red from '@material-ui/core/colors/red';
import EmailIcon from '@material-ui/icons/Email';
import SaveOutlined from '@material-ui/icons/SaveOutlined';
import DeleteOutline from '@material-ui/icons/DeleteOutlined';
import ShareIcon from '@material-ui/icons/Share';
import AttachFile from '@material-ui/icons/AttachFile';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Divider, Hidden, Grid } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import ChipInput from 'material-ui-chip-input'
import TextField from '@material-ui/core/TextField';
import TaskList from "./TaskList";
import TaskLogList from "./TaskLogList";
import TaskDialog from "./TaskDialog";
import DuplicateTxnTable from "./DuplicateTxnTable";
//tabs related import
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import Badge from '@material-ui/core/Badge';
//dialog related import
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import RoutineDescriptionTable from "./RoutineDescriptionTable";
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import AlertChip from "../AlertChip";
import { rgbToHex } from '@material-ui/core/styles/colorManipulator';

const styles = theme => ({
    padding: {
        padding: `0 ${theme.spacing.unit * 2}px`,
    },
    card: {
        width: "100%",
        height: '68vh',
    },
    header: {
          textAlign: "center"
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    actions: {
        display: 'flex',
        height: 56
    },
    content: {
          textAlign: "center",
        height: '55vh',
        overflow: "auto"
    },
    actionContent: {
          textAlign: "center",
        height: '50vh',
        overflow: "auto"
    },
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        marginLeft: 'auto',
        [theme.breakpoints.up('sm')]: {
            marginRight: -8,
        },
    },
    transaction: {
        paddingTop: 10,
        overflow: "auto",
        height: "10vh"
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },
});

class RecipeReviewCard extends React.Component {
    state = {
        expanded: false,
        actionView: false,
        chips: [],
        open: false,
        taskDialogOpen: false,
        //defaultTab
        value: 0,
        reason: 0,
        valueReason: 0,
    };

    handleExpandClick = () => {
        this.setState(state => ({ expanded: !state.expanded }));
    };
    handleViewToggle = () => {
        this.setState(state => ({ actionView: this.state.actionView ? false : true }));
    }
    handleClickOpen = () => {
        this.setState({ open: true });
    };
    handleTaskDialog = () => {
        this.setState({ taskDialogOpen: true });
    }
    handleTaskClickOpen = () => {

    }
    handleClose = () => {
        this.setState({ open: false });
    };

    handleChange = (event, value) => {
        this.setState({ value });
    };
    handleCloseDialogChange = name => event => {
        this.setState({ [name]: event.target.value });
    };
    handleChangeIndex = index => {
        this.setState({ value: index });
    };

    render() {
        const { classes } = this.props;
        const header = (
            <div>
                <span>ABC Pte Ltd</span>
                <span style={{ marginLeft: "10vw" }}>
                    <Chip
                        avatar={
                            <Avatar>
                                3
                            </Avatar>
                        }
                        label="Routines"
                    />
                    <Chip
                        avatar={
                            <Avatar>
                                65
                            </Avatar>
                        }
                        label="Transactions"
                    />
                </span>
            </div>
        )
        const testEmails = ["yongyibian@kpmg.com", "elisa@kpmg.com", "yuri@kpmg.com", "jiajie@kpmg.com", "koonhan@kpmg.com"]
        const inputHeader2 = (
            <ChipInput
                hintText='Assignees Email'
                dataSource={testEmails}
                fullWidth
            />
        )
        const inputHeader = (
            <TextField
                id="filled-full-width"
                label="To"
                style={{ margin: 8 }}
                placeholder="emails of the action recipient"

                fullWidth
                margin="normal"
                variant="filled"
                InputLabelProps={{
                    shrink: true,
                }}
            />
        )
        const dialog = (<Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            style={{ overflow: Hidden }}
        >
            <DialogTitle id="alert-dialog-title">{"Closing alert.."}</DialogTitle>
            <DialogContent style={{ width: "30vw", overflow: Hidden }}>
                <form>
                    <FormControl style={{ width: "30vw" }}>
                        <InputLabel htmlFor="age-simple" style={{ width: "30vw" }}>Please select reason for closure</InputLabel>
                        <Select
                            value={this.state.reason}
                            onChange={this.handleCloseDialogChange("reason")}
                            //input={<Input id="reason" />}
                            fullWidth
                            style={{ width: "30vw" }}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            <MenuItem value={1}>Data Input Error</MenuItem>
                            <MenuItem value={2}>Approval Obtained</MenuItem>
                            <MenuItem value={3}>Should not be flagged</MenuItem>
                            <MenuItem value={4}>Fraud</MenuItem>
                        </Select>
                    </FormControl>
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                    Cancel
              </Button>
                <Button onClick={this.handleClose} color="primary" autoFocus>
                    Submit
              </Button>
            </DialogActions>
        </Dialog>
        )
        const hardCodedChips = (
            <span>
                <AlertChip
                    label="Conflict Interest"
                    color="mid"
                />
                <AlertChip
                    label="Duplicate Address"
                    color="mid"
                />

            </span>
        )
        const actionView = (
            <Card className={classes.card}>

                <CardHeader
                    /*avatar={
                        <Button variant="outlined" size="medium" color="primary">
                            <EmailIcon />
                        </Button>
                    }*/
                    title={inputHeader}
                    className={classes.header}
                />
                <Divider />

                <CardContent className={classes.actionContent}>
                    <span style={{ color: "rgb(117,117,117)" }}>Remarks</span>
                    <textarea style={{ width: "42vw", height: "40vh", fontSize: "1.1em" }} placeholder="Please input reasons or instructions before you dispatch this alert to another person in charge"></textarea>
                    <span style={{ width: "42vw", display: "flex", justifyContent: "space-between" }}>
                        <span>
                            <Button variant="contained" size="small">
                                <AttachFile />
                                Attach File
                            </Button>
                        </span>
                        <span style={{ width: "18vw", display: "flex", justifyContent: "space-between" }}>
                            <Button variant="contained" size="small" style={{ width: "5vw" }}>
                                <SaveOutlined />
                                Save
                            </Button>
                            <Button variant="contained" size="small" onClick={this.handleViewToggle} style={{ width: "5vw" }}>
                                <DeleteOutline />
                                Discard
                            </Button>
                            <Button variant="contained" size="small" style={{ width: "5vw" }}>
                                <EmailIcon />
                                Send
                            </Button>
                        </span>
                    </span>
                </CardContent>
            </Card>
        );
        const detailsView = (
            <Card className={classes.card}>
                {this.state.taskDialogOpen ? <TaskDialog open={true} /> : null}
                <CardActions className={classes.actions}>
                    <Button style={{ width: "8vw" }} variant="outlined" onClick={this.handleClickOpen}>Close</Button>
                    <Button style={{ width: "8vw" }} variant="outlined" onClick={this.handleViewToggle}>Approve</Button>
                    <Button style={{ width: "8vw" }} variant="outlined" onClick={this.handleClickOpen}>Assign To</Button>
                    <Button style={{ width: "8vw" }} variant="outlined" onClick={this.handleTaskDialog}>Create Task</Button>
                    <IconButton
                        className={classnames(classes.expand, {
                            [classes.expandOpen]: this.state.expanded,
                        })}
                        onClick={this.handleExpandClick}
                        aria-expanded={this.state.expanded}
                        aria-label="Show more"
                    >
                        <ChevronRight />
                    </IconButton>
                </CardActions>
                <Divider />
                <CardContent className={classes.content}>
                    <RoutineDescriptionTable alert={this.props.alert} />
                    <DuplicateTxnTable />
                </CardContent>

                {dialog}
            </Card>
        );
        const routineTabs = (
            <div>
                <Tabs
                    className={classes.actions}
                    value={this.state.value}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleChange}
                >
                    <Tab label="Details" />
                    <Tab label={
                        <Badge color="secondary" className={classes.padding} badgeContent={3} >
                            Task List
                      </Badge>
                    } />
                    <Tab label="Action Logs" />
                </Tabs>
                <Divider />
                {this.state.value == 0 ? (this.state.actionView ? actionView : detailsView) : null}
                {this.state.value === 1 ? <TaskList /> : null}
                {this.state.value === 2 ? <TaskLogList /> : null}
                <Divider />
            </div>
        )
        return (
            <div>
                <Grid container spacing={16} width={{width: "100vw"}}>
                    <Grid item md={6}> {routineTabs}</Grid>
                    <Grid item md={6}> {routineTabs}</Grid>
                    {routineTabs}
                </Grid>
            </div>
        );
    }
}

RecipeReviewCard.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RecipeReviewCard);


// WEBPACK FOOTER //
// ./src/components/Routines/FSDialogListDetail.js